<template>
    <v-card rounded class="inventory-filter">
        <v-row class="row--sm">
            <!-- 상품명 -->
            <v-col cols="12">
                <v-text-field v-model="query.searchValue" v-bind="attrs_input" append-icon="mdi-magnify" placeholder="상품명을 검색하세요."></v-text-field>
            </v-col>

            <!-- 입고/출고 일자 -->
            <v-col cols="12">
                <v-row align="center" class="row--xs">
                    <v-col>
                        <v-text-field v-model="query['searchDateValue'][0]" v-bind="attrs_input" type="date" placeholder="0000-00-00"></v-text-field>
                    </v-col>
                    <v-col cols="auto" class="txt txt--xs">~</v-col>
                    <v-col>
                        <v-text-field v-model="query['searchDateValue'][1]" v-bind="attrs_input" type="date" placeholder="0000-00-00"></v-text-field>
                    </v-col>
                </v-row>
            </v-col>

            <!-- 단가(원가) -->
            <v-col cols="12">
                <v-row align="center" class="row--xs">
                    <v-col>
                        <v-text-field v-model="query.purchasePrice__total_min" v-bind="attrs_input" placeholder="1,000" append-icon="mdi-currency-krw"></v-text-field>
                    </v-col>
                    <v-col cols="auto" class="txt txt--xs">~</v-col>
                    <v-col>
                        <v-text-field v-model="query.purchasePrice__total_max" v-bind="attrs_input" placeholder="10,000" append-icon="mdi-currency-krw"></v-text-field>
                    </v-col>
                </v-row>
            </v-col>

            <!-- 단가(원가) -->
            <v-col cols="12">
                <v-row class="row--xs">
                    <v-col>
                        <v-row align="center" class="row--xs">
                            <v-col>
                                <v-row align="center" class="row--xs">
                                    <v-col>
                                        <v-text-field v-model="query.amount_min" v-bind="attrs_input" placeholder="00"></v-text-field>
                                    </v-col>
                                    <v-col cols="auto" class="txt txt--xs">개</v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="auto" class="txt txt--xs">~</v-col>
                            <v-col>
                                <v-row align="center" class="row--xs">
                                    <v-col>
                                        <v-text-field v-model="query.amount_max" v-bind="attrs_input" placeholder="00"></v-text-field>
                                    </v-col>
                                    <v-col cols="auto" class="txt txt--xs">개</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="auto"><v-btn color="grey" class="w-lg-80px" v-bind="{ loading }" @click="emit">조회</v-btn></v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import { attrs_input } from "@/assets/variables";

const initQuery = (query = {}) => ({
    searchValue: query?.searchValue || null,
    ["searchDateValue"]: [...(query["searchDateValue"] ?? [null, null])],
    purchasePrice__total_min: query?.purchasePrice__total_min || null,
    purchasePrice__total_max: query?.purchasePrice__total_max || null,
    amount_min: query?.amount_min || null,
    amount_max: query?.amount_max || null,
});

export default {
    components: {},
    props: {
        loading: { type: Boolean, default: false },
    },
    setup: () => ({
        attrs_input,
    }),
    data: () => ({
        query: initQuery(),
    }),
    computed: {},
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query.page;

            if (query.searchValue) query.searchKey = "fullName";
            if (!query.searchValue) delete query.searchValue;
            if (!query["searchDateValue"][0] && !query["searchDateValue"][1]) delete query["searchDateValue"];
            if (!query.purchasePrice__total_min) delete query.purchasePrice__total_min;
            if (!query.purchasePrice__total_max) delete query.purchasePrice__total_max;
            if (!query.amount_min) delete query.amount_min;
            if (!query.amount_max) delete query.amount_max;

            this.$router.push({ query });
        },
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
.inventory-filter {
    background-color: var(--v-grey-lighten5);
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
    border-top: 1px solid;
    border-color: var(--v-grey-lighten4) !important;
    padding: 18px;
}

@media (min-width: 768px) {
    .inventory-filter {
        padding: 24px;
    }
}
</style>
